export class Kinship {
    get id() {
        return this.kinshipState.id;
    }
    get name() {
        return this.kinshipState.name;
    }
    get kinship() {
        return this.kinshipState.kinship;
    }
    get member() {
        return this.kinshipState.member;
    }
    set id(id) {
        this.kinshipState.id = id;
    }
    set name(name) {
        this.kinshipState.name = name;
    }
    set kinship(kinship) {
        this.kinshipState.kinship = kinship;
    }
    set member(member) {
        this.kinshipState.member = member;
    }
    constructor(kinshipState) {
        this.kinshipState = kinshipState;
    }
    getState() {
        return this.kinshipState;
    }
}
